<template>
    <modal :show="show" >

        <div style="margin-bottom:0px" class="card" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
            <div class="card-body">
                <div class="col-lg-12">
                    <div class="tab-content" id="nav-tabContent">
                        <div class="modal-header" v-if="type=='Edit'">

                            <h5 class="modal-title DayHeading" id="myModalLabel"> {{ $t('AddRegion.UpdateRegion') }} </h5>

                        </div>
                        <div class="modal-header" v-else>

                            <h5 class="modal-title DayHeading" id="myModalLabel">{{ $t('AddRegion.CreateRegion') }} </h5>

                        </div>
                        <div class="">
                            <div class="card-body">
                                <div class="row ">
                                    <div :key="render" class="form-group has-label col-sm-12 " v-bind:class="{'has-danger' : $v.region.code.$error} && ($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                        <label class="text  font-weight-bolder"> {{ $t('AddRegion.Code') }}:<span class="LabelColour"> *</span></label>
                                        <input disabled class="form-control" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-model="$v.region.code.$model" type="text" />
                                        <span v-if="$v.region.code.$error" class="error">
                                            <span v-if="!$v.region.code.maxLength">{{ $t('AddRegion.CodeLength') }}</span>
                                        </span>
                                    </div>

                                    <div class="form-group has-label col-sm-12 " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                        <label class="text  font-weight-bolder">{{ $t('AddRegion.SelectCountry') }}: <span class="LabelColour"> *</span></label>
                                        <countrydropdown v-model="region.countryId" :values="region.countryId" v-on:input="RanderProvince"></countrydropdown>

                                    </div>
                                    <div class="form-group has-label col-sm-12 " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                        <label class="text  font-weight-bolder"> {{ $t('AddRegion.SelectState') }}: <span class="LabelColour"> *</span></label>
                                        <provincedropdown v-model="region.stateId" :values="region.stateId" v-bind:country="region.countryId.id==null?region.countryId:region.countryId.id" v-bind:key="rander"></provincedropdown>

                                    </div>
                                    <div class="form-group has-label col-sm-12 " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                        <label class="text  font-weight-bolder"> {{ $t('AddRegion.SelectCity') }}: <span class="LabelColour"> *</span></label>
                                        <citydropdown v-model="region.cityId" v-bind:values="region.cityId" v-bind:key="rander"></citydropdown>

                                    </div>
                                    <div class="form-group has-label col-sm-12 " v-bind:class="{'has-danger' : $v.region.area.$error} && ($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                        <label class="text  font-weight-bolder"> {{ $t('AddRegion.Area') }}: <span class="LabelColour"> *</span></label>
                                        <input class="form-control" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" v-model="$v.region.area.$model" type="text" />
                                        <span v-if="$v.region.area.$error" class="error">
                                            <span v-if="!$v.region.area.required">{{ $t('AddRegion.NameRequired') }}</span>
                                            <span v-if="!$v.region.area.maxLength">{{ $t('AddRegionNameLength') }}</span>
                                        </span>
                                    </div>


                                    <div class="form-group col-md-12">
                                        <label style="margin: 7px;">{{ $t('AddRegion.Active') }}</label> <br />
                                        <div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" v-bind:class="{'bootstrap-switch-on': region.isActive, 'bootstrap-switch-off': !region.isActive}" v-on:click="region.isActive = !region.isActive" style="width: 72px;">
                                            <div class="bootstrap-switch-container" style="width: 122px; margin-left: 0px;">
                                                <span class="bootstrap-switch-handle-on bootstrap-switch-success" style="width: 50px;">
                                                    <i class="nc-icon nc-check-2"></i>
                                                </span>
                                                <span class="bootstrap-switch-label" style="width: 30px;">&nbsp;</span>
                                                <span class="bootstrap-switch-handle-off bootstrap-switch-success" style="width: 50px;">
                                                    <i class="nc-icon nc-simple-remove"></i>
                                                </span>
                                                <input class="bootstrap-switch" type="checkbox" data-toggle="switch" checked="" data-on-label="<i class='nc-icon nc-check-2'></i>" data-off-label="<i class='nc-icon nc-simple-remove'></i>" data-on-region="success" data-off-region="success">
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                        <div class="modal-footer justify-content-right" v-if="type=='Edit'" >

                            <button type="button" class="btn btn-primary  " v-on:click="SaveRegion" v-bind:disabled="$v.region.$invalid"> {{ $t('AddRegion.btnUpdate') }}</button>
                            <button type="button" class="btn btn-danger  mr-3 " v-on:click="close()">{{ $t('AddRegion.btnClear') }}</button>

                        </div>
                        <div class="modal-footer justify-content-right" v-if="type!='Edit'">

                            <button type="button" class="btn btn-primary  " v-on:click="SaveRegion" v-bind:disabled="$v.region.$invalid"> {{ $t('AddRegion.btnSave') }}</button>
                            <button type="button" class="btn btn-danger  mr-3 " v-on:click="close()">{{ $t('AddRegion.btnClear') }}</button>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </modal>
</template>
<script>
    import clickMixin from '@/Mixins/clickMixin'
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { required, maxLength } from "vuelidate/lib/validators"

    export default {
        props: ['show', 'region', 'type'],
        mixins: [clickMixin],
        data: function () {
            return {
                rander: 0,
                render: 0,
            }
        },
        validations: {
            region: {
                code: {
                    maxLength: maxLength(30)
                },
                area: {
                    required,
                    maxLength: maxLength(50)
                },
                cityId: {
                    required,
                },
                stateId: {
                    required,
                },
            }
        },
        methods: {
            RanderProvince: function () {
                
                this.rander++;
            },
            close: function () {
                
                this.$emit('close');
            },
            GetAutoCodeGenerator: function () {
                
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                this.$https.get('/Region/RegionCode', { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    
                    if (response.data != null) {
                        root.region.code = response.data;
                        root.render++;
                    }
                });
            },
            SaveRegion: function () {
                
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                this.region.description = this.region.countryId.name;
                this.region.countryId = this.region.countryId.id;
              
                this.$https.post('/Region/SaveRegion', this.region, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data.isSuccess == true) {
                        
                        if (root.type != "Edit") {
                           
                            root.$swal({
                                title: "Saved!",
                                text: "Saved Successfully!",
                                type: 'success',
                                icon: 'success',
                                showConfirmButton: false,
                                timer: 1500,
                                timerProgressBar: true,
                            });
                            
                            root.close();
                        }
                        else {
                          
                           
                          
                            root.$swal({
                                title: "Saved!",
                                text: "Update Sucessfully!",
                                type: 'success',
                                icon: 'success',
                                showConfirmButton: false,
                                timer: 1500,
                                timerProgressBar: true,
                            });
                            root.close();
                        }
                    }
                    else {
                        root.$swal({
                            title: "Error!",
                            text: "Your Region Name  Already Exist!",
                            type: 'error',
                            icon: 'error',
                            showConfirmButton: false,
                            timer: 1500,
                            timerProgressBar: true,
                        });
                    }
                });
            }
        },
        mounted: function () {
            
            if (this.region.id == '00000000-0000-0000-0000-000000000000' || this.region.id == undefined || this.region.id == '')
                this.GetAutoCodeGenerator();
            

        }
    }
</script>
